import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Popover, Row, Skeleton } from "antd";
import moment from "moment";

import queryLogApi from "../../apis/QueryLog.api";

const PopularProducts = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);
	const [dateLength, setDateLength] = useState(2);
	const [productList, setProductList] = useState([]);

	useEffect(() => {
		const timer = setTimeout(() => {
			getTogetherProducts();
		}, 100);
		return () => clearTimeout(timer);
	}, [user, dateLength]);

	const getTogetherProducts = useCallback(async () => {
		setLoading(true);
		const param = {
			offset: 0,
			pageSize: 5,
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			startDate: moment()
				.subtract(dateLength, "days")
				.startOf("days")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
		};
		const res = await queryLogApi.queryLogTogetherProducts(param);
		if (res.code === 200) {
			setProductList(res.result);
		}
		setLoading(false);
	}, [user, dateLength]);

	return (
		<div className={`dashboard-component`} style={{ width: "100%" }}>
			<h3>인기 영양제 TOP 5</h3>

			<div className={`dashboard-popular-category-list`}>
				<div className={`table-list-row`}>
					<p className={`category-font`} style={{ width: "85%" }}>
						영양제명
					</p>
					<p
						className={`number-font`}
						style={{
							maxWidth: "15%",
						}}
					>
						총 클릭수
					</p>
					{/*<p className={`number-font`}>*/}
					{/*    실시간 상승*/}
					{/*</p>*/}
				</div>
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
						padding: "1em 0",
					}}
					title={null}
					paragraph={{
						rows: 5,
						width: "100%",
					}}
				>
					{productList?.map((item, idx) => (
						<Popover
							content={item?.category_name}
							trigger="hover, click"
							key={`product-popover-${idx}`}
						>
							<div
								className={`table-list-row`}
								key={`popular-category-${idx}`}
								style={{
									cursor: "pointer",
								}}
							>
								<div
									className={`category-font`}
									style={{
										display: "flex",
										alignItems: "center",
										gap: "0.5em",
										width: "85%",
										maxWidth: "85%",
									}}
								>
									<p>{idx + 1}</p>
									<p className={`table-category-id`}>{item.brand_name}</p>
									<p className={`table-category-name`}>{item.product_name}</p>
								</div>
								<p
									className={`number-font`}
									style={{
										maxWidth: "15%",
										// color: "#df1d1d",
										color: "#212529",
									}}
								>
									{item?.product_count?.toLocaleString()}
								</p>
								{/*<p className={`number-font`}*/}
								{/*   style={{*/}
								{/*       color: "#117ffa"*/}
								{/*   }}*/}
								{/*>*/}
								{/*    + {item?.view_num?.toLocaleString()}*/}
								{/*</p>*/}
							</div>
						</Popover>
					))}
				</Skeleton>
			</div>

			{!productList?.length && !loading && (
				<Row
					align={"middle"}
					style={{
						width: "100%",
						flexDirection: "column",
						padding: "2em 0",
					}}
				>
					<img
						src={`/assets/images/warning.png`}
						alt={`warning-icon`}
						style={{
							width: "3em",
							height: "auto",
						}}
					/>
					<p
						style={{
							marginTop: "1em",
							color: "#adb5bd",
							fontSize: "1.1em",
							fontWeight: 500,
						}}
					>
						조회된 상품 목록이 없습니다.
					</p>
				</Row>
			)}
			<p className={`light-gray`} style={{ marginLeft: "auto" }}>
				2일 기준
			</p>
			<div className={`dashboard-component-footer`}>
				<Link
					to={`/reports_analysis/products`}
					className={`dashboard-footer-font`}
				>
					영양제 분석으로 이동
				</Link>
			</div>
		</div>
	);
};

export default PopularProducts;
